<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="pi"></a> Copyright © 2005 by Tony La Russa and H.G. Bissinger</p>
<p class="timebreak"> <br/></p>
<p class="left"><span style="font-size: smaller">ALL RIGHTS RESERVED</span></p>
<p class="timebreak"> <br/></p>
<p class="left">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="left"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="left"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Bissinger, H. G.<br/>
Three nights in August / Buzz Bissinger.<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 0-618-40544-5<br/>
1. St. Louis Cardinals (Baseball team) 2. Chicago Cubs (Baseball team) 3. La Russa, Tony. I. Title.<br/>
GV875.S74B57 2005<br/>
796.357'09778'66—dc22 2004065134</p>
<p class="timebreak"> <br/></p>
<p class="left">e<span style="font-size: smaller">ISBN</span> 978-0-547-52671-3<br/>
v2.0714</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?42478bc5